import { WidgetCacheApi } from './index'

export const patchDefaultEmbed = (operations) => {
  return WidgetCacheApi.patch('/embeds/_default/configuration', operations)
}
